var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { Trans } from 'react-i18next';
import { observer } from 'mobx-react';
import ChannelsForm from './ChannelsForm';
import ChannelsActionsForm from './ChannelsActionsForm';
import { useStore } from '../../../../../../store/rootStore';
import s from './ChannelsForm.module.scss';
const ChannelsFormWrapper = (props) => {
    const { entity } = props, formProps = __rest(props, ["entity"]);
    const { channels } = useStore();
    const [hasActions, setHasActions] = useState(false);
    useEffect(() => {
        if (entity) {
            channels.fetchChannelActions(entity.channel, entity.accountId)
                .then((actions) => setHasActions(actions.length > 0))
                .catch(() => setHasActions(false));
        }
        else {
            setHasActions(false);
        }
    }, [entity]);
    if (!entity || !hasActions) {
        return React.createElement(ChannelsForm, Object.assign({}, formProps, { entity: entity }));
    }
    const tabItems = [
        {
            key: 'settings',
            label: React.createElement(Trans, { i18nKey: "settings" }),
            children: React.createElement(ChannelsForm, Object.assign({}, formProps, { entity: entity })),
        },
        {
            key: 'actions',
            label: React.createElement(Trans, { i18nKey: "channelActions" }),
            children: React.createElement(ChannelsActionsForm, { entity: entity }),
        },
    ];
    return (React.createElement(Tabs, { defaultActiveKey: "settings", className: s.formTabs, items: tabItems }));
};
export default observer(ChannelsFormWrapper);
